'use client';
import { memo, useCallback } from 'react';
import { ChartTooltip, PositionRelative, SvgChart } from '../lib/components';
import { Axes, Clipping, Grid, HoverMarker } from '../lib/components/Graph';
import { Circle, Line } from '../lib/components/Shapes';
import { useScaleLinearX, useScaleLinearY } from '../lib/hooks/d3';
import { useFilterUnselected } from '../lib/hooks/data';
import { max } from '../lib/utils';

const Lines = ({ data, tooltipData, groups, mappings, totalText, onClick }: any) => {
  const filteredMappings = useFilterUnselected(mappings);
  const reverseMappings = filteredMappings.slice().reverse();
  const maxValue = Math.ceil(max(data, d => max(reverseMappings, m => d[m.dataKey])) || 1);

  const scaleX = useScaleLinearX(0, data.length - 1);
  const scaleY = useScaleLinearY(0, maxValue);

  const getHoveredTick = useCallback((x: any) => Math.round(scaleX.invert(x)), [scaleX]);

  return (
    <PositionRelative>
      <SvgChart
        getHoveredTick={getHoveredTick}
        onClick={onClick ? tick => onClick({ tick, filteredMappings }) : undefined}
      >
        <Grid scaleX={scaleX} scaleY={scaleY} />
        <Clipping>
          {reverseMappings.map(({ id, dataKey, color }: any) => (
            <Line
              key={id}
              data={data}
              keyY={dataKey}
              scaleX={scaleX}
              scaleY={scaleY}
              stroke={color}
              strokeWidth={3}
            />
          ))}
        </Clipping>
        <Axes data={data} scaleX={scaleX} scaleY={scaleY} />
        <HoverMarker
          data={data}
          scaleX={scaleX}
          scaleY={scaleY}
          mappings={reverseMappings}
          Point={Circle}
        />
      </SvgChart>
      <ChartTooltip
        data={tooltipData || data}
        groups={groups}
        scaleX={scaleX}
        dataSeries={filteredMappings}
        totalText={totalText}
      />
    </PositionRelative>
  );
};

export default memo(Lines);
